import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { teacherAssistantSignIn } from "../Store/api/auth";
import { Formik, ErrorMessage } from "formik";
import SideBar from "./SideBar";
import loginSchema from "../ValidationScheema/LoginScheema";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import storage from "../services/storage";
import { Link } from "react-router-dom";
import Loader from "../components/Loader";
import DraggableSidebar from "../components/DraggableSidebar";

import { useNavigate, useLocation } from "react-router-dom";

const loginFormInitialValues = {
  email: "",
  password: "",
};

let verifyLink;

export const TeacherAssistantSignIn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  /*  const [searchParams] = useSearchParams();
  const taEmail = searchParams.get("taEmail");
  const profId = searchParams.get("profId");
  const emailExist = searchParams.get("existInDB");
  const sectionId = searchParams.get("sectionId"); */

  useEffect(() => {
    const token = storage.get("xAuthToken");
    if (token) {
      navigate("/home", { replace: true });
    }
  }, []);

  //loader
  const [loading, setLoading] = useState(false);
  //Alert Message
  const [errorMessage, setErrorMessage] = useState({
    type: "success",
    message: "",
  });

  const onSubmit = async (values, action) => {
    const storedSearchParamsString = localStorage.getItem("searchParams");
    setLoading(true);
    dispatch(
      teacherAssistantSignIn({
        body: values,
        onSuccess: (res) => {
          const { emailVerified } = res.data.data;
          setLoading(false);
          action.resetForm();
          {
            storedSearchParamsString
              ? navigate(`/ta/?${storedSearchParamsString}`, { replace: true })
              : navigate("/tahome", { replace: true });
          }

          // navigate("/teacherAssistantSignin", {replace: true});

          if (!emailVerified) {
            if (verifyLink) verifyLink.click();
          }
          setErrorMessage({ type: "danger", message: "" });
        },
        onError: (err) => {
          if (err.response && err.response.data && err.response.data.message) {
            setErrorMessage({
              type: "danger",
              message: err.response.data.message,
            });
          }
        },
        onEnd: () => {
          setLoading(false);
        },
      })
    );
  };

  return (
    <div className="flex-container">
      <div
        // className="col-xxl-1 col-xl-1 col-lg-12 col-md-12 px-0"
        className="activity-spectrum"
      >
        <div>
          <DraggableSidebar
          /*  scrollBook={scrollToSection}
                scrollCentre={scrollWithSpectrum} */
          />
        </div>
      </div>
      <div style={{ width: "97.9%" }}>
        <Formik
          initialValues={loginFormInitialValues}
          validationSchema={loginSchema}
          onSubmit={onSubmit}
        >
          {({ values, handleChange, handleBlur, handleSubmit }) => (
            <section className="class_room_wrap">
              <div className="custom_container">
                <div className="row">
                  <div className="col-xxl-3 col-xl-5 col-lg-5 col-md-12 px-0  pb-0">
                    <SideBar tabContents="class" />
                  </div>
                  <div
                    className="col-xxl-6 col-xl-7 col-lg-7 col-md-12"
                    style={{ marginTop: "72px" }}
                  >
                    <div className="welcome_wrap ">
                      <h1 className="main_title mb-4 pt-100 ">welcome back</h1>

                      <div className="row1">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <input
                              type="email"
                              className="form-control"
                              name="email"
                              placeholder="Email address"
                              value={values.email}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              autoComplete="off"
                            />{" "}
                            <div className="err-end">
                              <p className="error-msg">
                                <ErrorMessage
                                  className="error-msg"
                                  name="email"
                                />
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group">
                            <input
                              type="Password"
                              className="form-control"
                              placeholder="Password"
                              name="password"
                              value={values.password}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              autoComplete="off"
                            />{" "}
                            <div className="err-end">
                              <p className="error-msg">
                                <ErrorMessage
                                  className="error-msg"
                                  name="password"
                                />
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="btn_Wrap mt-30">
                            <button
                              type="submit"
                              className="btn_black_theme w-100 d-block"
                              onClick={handleSubmit}
                              disabled={loading ? true : false}
                            >
                              {loading ? (
                                <div className="loader">
                                  <Loader />
                                </div>
                              ) : (
                                "Sign In"
                              )}
                            </button>
                            {/*    )} */}

                            {/* <ToastContainer /> */}
                            <p className="agrre-to mt-20 pb-55 pdl-8">
                              By signing up, you agree to be contacted by
                              greyled and its partners.{" "}
                              <a
                                href="https://greyled.com"
                                className="font-whi"
                              >
                                <u>Learn more</u>
                              </a>
                            </p>
                            <div>
                              {" "}
                              {errorMessage.message && (
                                <div
                                  className={`alert alert-${errorMessage.type}`}
                                >
                                  {errorMessage.message}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="footer_bottom">
                            <p className="have-account">
                              Don't have an account?{" "}
                              {/*<Link to="/ta" className=" ">
                                <u>Sign up</u>
                              </Link> */}
                              <Link to="/teacherassistantsignup" className=" ">
                                <u>Sign up</u>
                              </Link>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
        </Formik>
      </div>
    </div>
  );
};
